// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available workspace actions
export const WORKSPACE_ACTIONS_KEY = {
  LINK_TO_DATASET: 'LINK_TO_DATASET',
  GET_ALL_WORKSPACES: 'GET_ALL_WORKSPACES',
  SELECT_WORKSPACE: 'SELECT_WORKSPACE',
  SET_ALL_WORKSPACES: 'SET_ALL_WORKSPACES',
  SET_CURRENT_WORKSPACE: 'SET_CURRENT_WORKSPACE',
  RESET_CURRENT_WORKSPACE: 'RESET_CURRENT_WORKSPACE',
};
